/**
 * 极简 className 合并工具。
 * 不引入 clsx / classnames，避免一个三方包。
 */
export type ClassValue =
    | string
    | number
    | boolean
    | null
    | undefined
    | ClassValue[]
    | { [k: string]: unknown }

export function cn(...args: ClassValue[]): string {
    const out: string[] = []
    for (const arg of args) {
        if (!arg) continue
        if (typeof arg === 'string' || typeof arg === 'number') {
            out.push(String(arg))
        } else if (Array.isArray(arg)) {
            const inner = cn(...arg)
            if (inner) out.push(inner)
        } else if (typeof arg === 'object') {
            for (const key in arg) {
                if (arg[key]) out.push(key)
            }
        }
    }
    return out.join(' ')
}
